import { Component, Input, OnInit } from '@angular/core';
import { Album } from '../../shared-api/albums/album.model';
import { OrganizationManagerService } from '../../shared-api/organization/organization-manager.service';
import { Organization } from '../../shared-api/organization/organization.model';
import { take } from 'rxjs/operators';

@Component({
    selector: 'myapp-org-header',
    templateUrl: './org-header.component.html',
    styleUrls: [ './org-header.component.less' ]
})
export class OrgHeaderComponent implements OnInit
{
    @Input() album: Album;
    @Input() showLogo = true;
    organization: Organization;

    constructor(private orgManager: OrganizationManagerService) { }

    ngOnInit()
    {
        this.orgManager.currentOrganization.pipe(take(1)).subscribe(() =>
        {
            this.orgManager.getCurrentOrganizationImages().pipe(take(1)).subscribe(org =>
            {
                this.organization = org;
            });
        });
    }
}
